module.exports = __webpack_public_path__ + "video/main.mp4.57de1b2.mp4";